import { Link, type LinkProps } from "@tanstack/react-router";
import { tv } from "tailwind-variants";

import { focusRing, icons } from "@/ui";

const navigableListItemVariants = tv({
  slots: {
    link: [
      "group flex min-h-14 cursor-pointer items-center justify-between gap-4 rounded-card px-4 py-4 sm:px-5",
      "my-1.5 transition-colors duration-200 hover:bg-surface-hover hover:text-accent",
      focusRing,
    ],
    chevron:
      "size-5 shrink-0 text-content-muted transition-transform duration-200 group-hover:translate-x-1 group-hover:text-accent",
  },
});

const { chevron, link } = navigableListItemVariants();

type NavigableListItemProps = {
  title: string;
} & Pick<LinkProps, "to" | "params">;

export const NavigableListItem = ({ title, ...props }: NavigableListItemProps) => {
  return (
    <div className="border-b border-line">
      <Link className={link()} {...props}>
        <h3>{title}</h3>

        <icons.ChevronRightIcon aria-hidden="true" className={chevron()} />
      </Link>
    </div>
  );
};
